import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { preloadedLogo } from '../utils/imagePreloader';
import DemoTransferencias from '../components/DemoTransferencias';
import { createAuthService } from '../services/authService';
import './Login.css';

// Pantalla de ingreso. El flujo no cambió: se verifica que el usuario exista y se le manda
// un link de acceso por mail (authService.sendLoginLink). El campo está dentro de un <form>,
// así Enter envía el link igual que el botón.
function Login() {
    const [email, setEmail] = useState('');
    const [resultado, setResultado] = useState(null);
    const [cargando, setCargando] = useState(false);

    const enviarLink = async (e) => {
        e.preventDefault();
        if (cargando) return;

        const correo = email.trim();
        if (!correo) {
            setResultado({ tipo: 'error', texto: 'Ingresá tu email.' });
            return;
        }

        setCargando(true);
        setResultado(null);

        try {
            const authService = await createAuthService();
            const existe = await authService.usuarioExiste(correo);

            if (!existe) {
                setResultado({ tipo: 'error', texto: 'Ese email no está registrado. Registrate para empezar.' });
                return;
            }

            await authService.sendLoginLink(correo);
            setResultado({ tipo: 'ok', texto: 'Listo. Te mandamos un link a tu email para entrar.' });
        } catch (error) {
            console.error('Error al enviar link de acceso:', error);
            setResultado({ tipo: 'error', texto: 'No pudimos enviar el link. Probá de nuevo en un momento.' });
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="login-pantalla">
            <div className="login-tarjeta">
                <section className="login-form-lado">
                    <img src={preloadedLogo} alt="TransferisOK" className="login-logo-nuevo" />

                    <h1 className="login-titulo">Ingresá a tu cuenta</h1>
                    <p className="login-bajada">Te mandamos un link a tu email. Sin contraseñas.</p>

                    <form onSubmit={enviarLink} className="login-formulario" noValidate>
                        <label htmlFor="email-input" className="login-label">Email</label>
                        <input
                            id="email-input"
                            type="email"
                            inputMode="email"
                            autoComplete="email"
                            autoFocus
                            placeholder="tu@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="login-input"
                            disabled={cargando}
                        />
                        <button type="submit" className="login-boton" disabled={cargando}>
                            {cargando ? <span className="login-spinner" aria-hidden="true" /> : null}
                            {cargando ? 'Enviando…' : 'Enviar link de acceso'}
                        </button>
                    </form>

                    {resultado && (
                        <div className={`login-mensaje ${resultado.tipo}`} role="status">
                            {resultado.texto}
                        </div>
                    )}

                    <p className="login-registro">
                        ¿No tenés cuenta? <Link to="/registro">Registrate gratis</Link>
                    </p>

                    <a className="login-web" href="https://transferisok.com/" target="_blank" rel="noopener noreferrer">
                        transferisok.com
                    </a>
                </section>

                <aside className="login-info-lado" aria-hidden="true">
                    <DemoTransferencias />
                </aside>
            </div>
        </div>
    );
}

export default Login;
